import LocalStoragePersist from './persist/LocalStoragePersist.mjs';
import SessionStoragePersist from './persist/SessionStoragePersist.mjs';

const createVanillaStore = (initialState, options) => {
  let state = initialState;
  let persistStore = null;
  const callbacks = new Set();
  const get = () => state;
  const set = nextState => {
    if (typeof window === 'undefined') {
      throw new Error('This function is not available in Server side.');
    }
    state = typeof nextState === 'function' ? nextState(state) : nextState;
    callbacks.forEach(callback => callback());
    return state;
  };
  if (options?.persist) {
    const key = options.persist.key;
    if (options.persist.type === 'localStorage') {
      persistStore = new LocalStoragePersist(key, initialState, options.persist.typeAssertion);
      callbacks.add(() => {
        if (persistStore) {
          persistStore.value = get();
        }
      });
    }
    if (options.persist.type === 'sessionStorage') {
      persistStore = new SessionStoragePersist(key, initialState, options.persist.typeAssertion);
      callbacks.add(() => {
        if (persistStore) {
          persistStore.value = get();
        }
      });
    }
  }
  const subscribe = callback => {
    callbacks.add(callback);
    return () => {
      callbacks.delete(callback);
    };
  };
  return {
    get,
    set,
    subscribe,
    persistStore
  };
};

export { createVanillaStore };
